import { DownloadOutlined }     from '@ant-design/icons';
import type { FormInstance }    from 'antd';
import dayjs                    from 'dayjs';
import { Dayjs }                from 'dayjs';
import React                    from 'react';
import { Form }                 from 'antd';
import { Radio }                from 'antd';
import { Col }                  from 'antd';
import { DatePicker }           from 'antd';
import { TimePicker }           from 'antd';
import { Checkbox }             from 'antd';
import { Button }               from 'antd';
import { observer }             from 'mobx-react';
import FormattedMessageWrapper  from 'components/App/FormattedMessageWrapper';
import Input                    from 'components/App/IntlInput';
import RichTextEditor           from 'components/App/RichTextEditor';
import Select                   from 'components/App/IntlSelect';
import DemandLogisticMeans, {
  getTranslatedlMeanLabel,
}                               from 'constants/DemandLogisticMeans';
import FormItemUpload           from 'components/App/FormItemUpload';
import DemandConfigModel        from 'models/DemandConfigModel';
import DemandLogisticModel      from 'models/DemandLogisticModel';
import { appStore }             from 'stores/AppStore';
import handleFormError          from 'utils/handleFormError';
import { ApiCollection }        from 'collections/ApiCollection';
import {
  LOGISTIC_MATERIAL,
  LOGISTIC_VEHICLE,
  getDemandTypeIntlLabel,
}                               from 'constants/DemandTypes';
import DemandTypeModel          from 'models/DemandTypeModel';
import { downloadFileFromBlob } from 'utils/downloadFile';
import Space                    from 'components/App/Space';
import DemandModelPdfModel      from 'models/DemandModelPdfModel';
import DemandStatusModel        from 'models/DemandStatusModel';
import { IN_PROGRESS }          from 'constants/DemandStatuses';
import DemandLogisticMediaModel from 'models/DemandLogisticMediaModel';
import DemandModel              from 'models/DemandModel';
import Row                      from 'components/App/Row';
import StandModel               from 'models/StandModel';
import { messageErrorIntl }     from 'utils/messageIntl';
import { AppFormComponent }     from 'components/App/AppForm';

type FileType = { lastModified?: number; lastModifiedDate?: string; name: string; originFileObj: null; uid: string };

const { Option } = Select;

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
};

interface DemandLogisticFormProps {
  demandConfigs: DemandConfigModel[];
  demandLogistic: DemandLogisticModel;
  demandLogisticMediaDocument: DemandLogisticMediaModel;
  demandLogisticMediaPlan: DemandLogisticMediaModel;
  model: DemandModel;
  onSuccess?: (demand: DemandModel) => void;
  stand: StandModel;
}

@observer
class DemandLogisticForm extends AppFormComponent<DemandLogisticFormProps> {
  public demandStatusCollection = new ApiCollection(DemandStatusModel);
  public demandTypeCollection = new ApiCollection(DemandTypeModel);

  public formRef: React.RefObject<FormInstance> = React.createRef<FormInstance>();

  public state = {
    demandTypeSelected: undefined,
  };

  public componentDidMount() {
    const {
      demandLogistic,
      demandLogisticMediaDocument,
      demandLogisticMediaPlan,
      model,
    } = this.props;

    this.setState({ demandTypeSelected: model.demandTypeIri });

    const values: {
      askedDate?: Dayjs;
      askedTime?: Dayjs;
      company?: string;
      demandType?: string;
      document: FileType[];
      email?: string;
      firstname?: string;
      height?: number;
      lastname?: string;
      length?: number;
      means?: string[];
      phone?: string;
      pickupDate?: Dayjs;
      pickupTime?: Dayjs;
      plan: FileType[];
      weight?: number;
      width?: number;
    } = {
      askedDate: model.askedDatetimeDate || undefined,
      askedTime: model.askedDatetimeDate || undefined,
      // comment: model.comment, // only at post
      company: model.company,
      demandType: model.demandTypeIri,
      document: [],
      email: model.email,
      firstname: model.firstname,
      height: demandLogistic.height,
      lastname: model.lastname,
      length: demandLogistic.length,
      means: demandLogistic.means,
      phone: model.phone,
      pickupDate: demandLogistic.pickupDatetimeDate || undefined,
      pickupTime: demandLogistic.pickupDatetimeDate || undefined,
      plan: [],
      weight: demandLogistic.weight,
      width: demandLogistic.width,
    };

    if (demandLogisticMediaDocument.id) {
      values.document.push({
        lastModified: undefined,
        lastModifiedDate: undefined,
        name: demandLogisticMediaDocument.mediaFileName,
        originFileObj: null,
        uid: demandLogisticMediaDocument.id.toString(),
      });
    }

    if (demandLogisticMediaPlan.id) {
      values.plan.push({
        lastModified: undefined,
        lastModifiedDate: undefined,
        name: demandLogisticMediaPlan.mediaFileName,
        originFileObj: null,
        uid: demandLogisticMediaPlan.id.toString(),
      });
    }

    this.formRef.current?.setFieldsValue(values);

    this.demandStatusCollection.list();

    this.demandTypeCollection.setFilter('reference', [LOGISTIC_VEHICLE, LOGISTIC_MATERIAL]);
    this.demandTypeCollection.list();
  }

  public render() {
    const { demandConfigs, model } = this.props;

    const demandStatus = this.demandStatusCollection.findBy('id', model.demandStatusId) as DemandStatusModel;
    const demandStatusInProgress = !demandStatus || demandStatus.reference === IN_PROGRESS;

    const demandConfig = demandConfigs.find(
      dConfig => dConfig?.demandType === this.state.demandTypeSelected,
    );

    const demandTypeRadios = this.renderDemandTypeRadios();

    return (
      <Form ref={this.formRef}>
        <Row>
          <Col span={24}>
            <u>
              <FormattedMessageWrapper id="Coordonnées de la personne responsable du stand :" />
            </u>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Société" />}
              labelCol={{ span: 24 }}
              name="company"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Nom" />}
              labelCol={{ span: 24 }}
              name="lastname"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Prénom" />}
              labelCol={{ span: 24 }}
              name="firstname"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Téléphone" />}
              labelCol={{ span: 24 }}
              name="phone"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Email" />}
              labelCol={{ span: 24 }}
              name="email"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <FormattedMessageWrapper id="Afin de faciliter l'arrivée et le départ du matériel volumineux de votre stand, merci de remplir ce formulaire." />
            <br />
            <FormattedMessageWrapper id="De quoi s'agit-il ?" />
          </Col>
          <Col span={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Votre demande concerne une demande de" />}
              labelCol={{ span: 24 }}
              name="demandType"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Radio.Group
                disabled={!!model.id}
                onChange={event => this.setState({ demandTypeSelected: event.target.value })}
              >
                {demandTypeRadios}
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={24}>
            <FormattedMessageWrapper id="En fonction des indications ci-dessous, le service technique vous contactera pour modifier ou enregistrer votre demande dans le planing d'arrivée/départ du matériel volumineux." />
          </Col>
          <Col md={6} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Hauteur" />}
              labelCol={{ span: 24 }}
              name="height"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col md={6} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Longueur" />}
              labelCol={{ span: 24 }}
              name="length"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col md={6} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Largeur" />}
              labelCol={{ span: 24 }}
              name="width"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col md={6} sm={24}>
            <Form.Item
              label={
                <FormattedMessageWrapper id="Poids (Précisez l'unité de mesure kg ou tonne.)" />
              }
              labelCol={{ span: 24 }}
              name="weight"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Moyens utilisés pour la livraison" />}
              labelCol={{ span: 24 }}
              name="means"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Select mode="multiple" style={{ width: '100%' }}>
                {DemandLogisticMeans.map(mean => (
                  <Option key={mean} value={mean}>
                    {getTranslatedlMeanLabel(mean)}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <i>
              <FormattedMessageWrapper id="Réservation du matériel choisi au soin de l'exposant." />
            </i>
          </Col>
        </Row>

        <br />

        <Space size={12}>
          <Row>
            <Col span={24}>
              <FormattedMessageWrapper id="Plan du positionnement du matériel" />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <FormattedMessageWrapper id="Veuillez accompagner ce formulaire d'un plan pour approbation par le service technique. Nous vous demanderons d'indiquer le positionnement du matériel ou du véhicule sur votre stand en respectant les retraits par rapports aux allées et cloisons mitoyennes." />
            </Col>
          </Row>
          <Row>
            <Col md={12} sm={24}>
              <FormattedMessageWrapper id="Télécharger ce document pour dessiner votre plan" />
            </Col>
            <Col md={12} sm={24}>
              <div style={{ display: 'flex' }}>
                <Button
                  icon={<DownloadOutlined />}
                  onClick={() => this.downloadDemandModelPdf(appStore.locale)}
                  style={{ marginRight: 8 }}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12} sm={24}>
              <FormattedMessageWrapper id="Puis joindre le plan complété" />
            </Col>
            <Col md={12} sm={24}>
              <FormItemUpload name="plan" />
            </Col>
          </Row>
        </Space>

        <Row>
          <Col md={12} sm={24}>
            <FormattedMessageWrapper id="Photo ou document du matériel" />
          </Col>
          <Col md={12} sm={24}>
            <FormItemUpload name="document" required={false} />
          </Col>
        </Row>

        <Row>
          <Col md={8} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Date souhaitée de livraison" />}
              labelCol={{ span: 24 }}
              name="askedDate"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <DatePicker
                disabled={!demandStatusInProgress}
                disabledDate={current => this.isDateDisabled(current, demandConfig)}
                format="DD/MM/YYYY"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Heure souhaitée de livraison" />}
              labelCol={{ span: 24 }}
              name="askedTime"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <TimePicker
                disabled={!demandStatusInProgress}
                format="HH[h]mm"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col md={8} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Date souhaitée d'enlèvement" />}
              labelCol={{ span: 24 }}
              name="pickupDate"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <DatePicker
                disabled={!demandStatusInProgress}
                disabledDate={current => this.isDateDisabled(current, demandConfig)}
                format="DD/MM/YYYY"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Heure souhaitée d'enlèvement" />}
              labelCol={{ span: 24 }}
              name="pickupTime"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <TimePicker
                disabled={!demandStatusInProgress}
                format="HH[h]mm"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
        </Row>

        {!model.id && (
          <>
            <Row>
              <Col span={24}>
                <Form.Item
                  label={<FormattedMessageWrapper id="Commentaire" />}
                  labelCol={{ span: 24 }}
                  name="comment"
                  rules={[
                    {
                      message: <FormattedMessageWrapper id="Information manquante" />,
                      required: true,
                    },
                  ]}
                >
                  <RichTextEditor style={{ height: 150, marginBottom: 32 }} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Item
                  name="confirmation"
                  rules={[
                    () => ({
                      message: <FormattedMessageWrapper id="Confirmation manquante" />,
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.reject();
                        }

                        return Promise.resolve();
                      },
                    }),
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={20}>
                <FormattedMessageWrapper id="J'ai bien pris en compte que cette demande ne donne droit à aucune dérogation sans l'acceptation de la part de nos équipes. Une réponse vous sera adressée prochainement." />
              </Col>
            </Row>
          </>
        )}
      </Form>
    );
  }

  public submit = async () => {
    const {
      demandLogistic,
      demandLogisticMediaDocument,
      demandLogisticMediaPlan,
      model,
      onSuccess,
      stand,
    } = this.props;

    const values = await this.formRef.current?.validateFields();

    const formatDatetime = (date: Dayjs, time: Dayjs) =>
      dayjs(`${date.format('YYYY-MM-DD')} ${time.format('HH:mm')}`).utc().format('YYYY-MM-DD HH:mm');

    try {
      await model.patch({
        askedDatetime: formatDatetime(values.askedDate, values.askedTime),
        comment: values.comment ? values.comment : undefined,
        company: values.company,
        demandType: values.demandType,
        email: values.email,
        firstname: values.firstname,
        lastname: values.lastname,
        phone: values.phone,
        stand: stand.get('@id'),
      });

      await demandLogistic.patch({
        demand: model.get('@id'),
        height: values.height,
        length: values.length,
        means: values.means,
        pickupDatetime: formatDatetime(values.pickupDate, values.pickupTime),
        weight: values.weight,
        width: values.width,
      });

      if (
        demandLogisticMediaDocument.id
        && demandLogisticMediaDocument.id !== values.document[0]?.uid
      ) {
        await demandLogisticMediaDocument.destroy();
      }

      if (values.document[0]?.originFileObj) {
        const newDemandLogisticMediaModel = new DemandLogisticMediaModel();

        newDemandLogisticMediaModel.set({
          demandLogistic: demandLogistic.iri,
          file: values.document[0].originFileObj,
          type: 'document',
        });

        await newDemandLogisticMediaModel.save();
      }

      if (
        demandLogisticMediaPlan.id
        && demandLogisticMediaPlan.id !== values.plan[0]?.uid) {
        await demandLogisticMediaPlan.destroy();
      }

      if (values.plan[0]?.originFileObj) {
        const newDemandLogisticMediaModel = new DemandLogisticMediaModel();

        newDemandLogisticMediaModel.set({
          demandLogistic: demandLogistic.iri,
          file: values.plan[0].originFileObj,
          type: 'plan',
        });

        await newDemandLogisticMediaModel.save();
      }

      if (onSuccess) {
        onSuccess(model);
      }
    } catch (error) {
      handleFormError(error, this.formRef.current);
    }
  };

  private downloadDemandModelPdf = async (locale: string) => {
    const { stand } = this.props;
    const demandModelPdf = new DemandModelPdfModel();
    demandModelPdf.set({ id: stand.id, locale });

    try {
      const response = await demandModelPdf.fetch();

      const blob = new Blob([response.data], { type: 'application/pdf' });

      const filename = response.headers['content-disposition'].replace('inline; filename=', '');

      downloadFileFromBlob(blob, filename);
    } catch {
      messageErrorIntl("Une erreur s'est produite.");
    }
  };

  private isDateDisabled = (date: Dayjs, demandConfig?: DemandConfigModel) => {
    if (!demandConfig) {
      return true;
    }

    let isAfter = false;
    if (demandConfig.demandsAfterDate && demandConfig.demandsAfterDate.isAfter(date, 'day')) {
      isAfter = true;
    }

    let isBefore = false;
    if (demandConfig.demandsBeforeDate && demandConfig.demandsBeforeDate.isBefore(date, 'day')) {
      isBefore = true;
    }

    return isAfter || isBefore;
  };

  private renderDemandTypeRadios = () => {
    const { demandConfigs } = this.props;

    return demandConfigs.map(dConfig => {
      const dTypeFound = this.demandTypeCollection.findBy('@id', dConfig?.demandType) as DemandTypeModel;

      if (!dTypeFound) {
        return <React.Fragment key={dConfig?.id} />;
      }

      return (
        <Radio key={dConfig?.id} style={radioStyle} value={dTypeFound.iri}>
          {getDemandTypeIntlLabel(dTypeFound)}
        </Radio>
      );
    });
  };
}

export default DemandLogisticForm;
